import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Badge } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './statistic-mark-line.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const StatisticMarkLineDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const statisticMarkLineEntity = useAppSelector(state => state.statisticMarkLine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="statisticMarkLineDetailsHeading">
          <Translate contentKey="fleetSenseApp.statisticMarkLine.detail.title">StatisticMarkLine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{statisticMarkLineEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="label">
              <Translate contentKey="fleetSenseApp.statisticMarkLine.label">Label</Translate>
            </span>
          </dt>
          <dd>{statisticMarkLineEntity.label}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.statisticMarkLine.sensor">Sensor</Translate>
          </dt>
          <dd>{statisticMarkLineEntity.sensor ? statisticMarkLineEntity.sensor.description : ''}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.statisticMarkLine.value">Value</Translate>
            </span>
          </dt>
          <dd>{statisticMarkLineEntity.value}</dd>
          <dt>
            <span id="lineType">
              <Translate contentKey="fleetSenseApp.statisticMarkLine.lineType">Line Type</Translate>
            </span>
          </dt>
          <dd><div style={{ maxWidth: '100px', padding: '10px 0 0 0', borderBottom: `5px ${statisticMarkLineEntity.lineType} ${statisticMarkLineEntity.color}` }} /></dd>
        </dl>
        <Button tag={Link} to="/statistic-mark-line" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/statistic-mark-line/${statisticMarkLineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default StatisticMarkLineDetail;
